//  this  pagge will containg a function handleExport. which will be used by other pages.
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import { discrepancyType } from 'custom/constants';
import { getStationDate } from 'utils/converter';
import moment from 'moment';

function getExportQuantity(billingFields, row) {
  function formatNumber(num) {
    return num % 1 === 0 ? Math.round(num) : num.toFixed(2);
  }
  let value;
  if (billingFields?.exclude_disc) {
    if (billingFields?.transit === 'none' || !billingFields?.transit) {
      value = !isNaN(parseFloat(row.quantity)) ? formatNumber(Math.round(parseFloat(row.quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'inbound') {
      value = !isNaN(parseFloat(row.in_quantity)) ? formatNumber(Math.round(parseFloat(row.in_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'outbound') {
      value = !isNaN(parseFloat(row.out_quantity)) ? formatNumber(Math.round(parseFloat(row.out_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.in_fquantity)) ? formatNumber(Math.round(parseFloat(row.in_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.out_fquantity)) ? formatNumber(Math.round(parseFloat(row.out_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.in_tquantity)) ? formatNumber(Math.round(parseFloat(row.in_tquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.out_tquantity)) ? formatNumber(Math.round(parseFloat(row.out_tquantity) * 100) / 100) : parseFloat(0);
    }
  } else {
    if (billingFields?.transit === 'none' || !billingFields?.transit) {
      value = !isNaN(parseFloat(row.dis_quantity)) ? formatNumber(Math.round(parseFloat(row.dis_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'inbound') {
      value = !isNaN(parseFloat(row.dis_in_quantity)) ? formatNumber(Math.round(parseFloat(row.dis_in_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'outbound') {
      value = !isNaN(parseFloat(row.dis_out_quantity)) ? formatNumber(Math.round(parseFloat(row.dis_out_quantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.dis_in_fquantity)) ? formatNumber(Math.round(parseFloat(row.dis_in_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'flight' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.dis_out_fquantity)) ? formatNumber(Math.round(parseFloat(row.dis_out_fquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'inbound') {
      value = !isNaN(parseFloat(row.dis_in_tquantity)) ? formatNumber(Math.round(parseFloat(row.dis_in_tquantity) * 100) / 100) : parseFloat(0);
    } else if (billingFields?.transit === 'truck' && billingFields?.priority === 'outbound') {
      value = !isNaN(parseFloat(row.dis_out_tquantity)) ? formatNumber(Math.round(parseFloat(row.dis_out_tquantity) * 100) / 100) : parseFloat(0);
    }
  }
  return value;
}

const get_csv_cont = async (billingData, billingFields) => { 
  let csv_cont = [];
  billingData.map((column) => {
    column?.inbound?.flights.map((flight) => {
      let trimlabel = flight.label?.split(' ')?.[0];
      let data = {
        'Flight': trimlabel?.split('/')?.[0],
        'Date':   trimlabel?.split('/')?.[1],
        'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
        'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
        'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
        'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
        'Segment': `${flight.org} - ${flight.dest}`,
        'Type': 'Inbound'
      };
      flight?.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
        data[row.item] = getExportQuantity(billingFields, row);
      });
      csv_cont.push(data);
    });
    column?.outbound?.flights.map((flight) => {
      let trimlabel = flight.label?.split(' ')?.[0];
      let data = {
        'Flight': trimlabel?.split('/')?.[0],
        'Date':   trimlabel?.split('/')?.[1],
        'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
        'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
        'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
        'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
        'Segment': `${flight.org} - ${flight.dest}`,
        'Type': 'Outbound'
      };
      flight?.contractData.filter(item => item.is_nonbillable !== true).map((row) => {
        data[row.item] = getExportQuantity(billingFields, row);
      });
      csv_cont.push(data);
    });
  });
  return csv_cont;
};

const get_csvpage_cont = async (sheetType, billingFields, billingData, reportFields, flightSumOpts, flightDetOpts) => {
// This function generates a summary table from billingData, similar to get_csv_cont,
// but sums up quantities for noncommercialData columns based on sheetType and removes unnecessary columns.

  let csv_cont = [];

  // Helper: For a given contractData array and commercial_items, sum up the quantities
  function sumCommercialItems(contractData, commercial_items, billingFields) {
    let sum = 0;
    contractData.forEach(row => {
      if (commercial_items.includes(parseInt(row.cont_rowId))) {
        sum += parseFloat(getExportQuantity(billingFields, row)) || 0;
      }
    });
    return sum;
  }

  function groupAndSumRows(csv_cont) {
    const grouped = {};

    csv_cont.forEach(row => {
      const key = `${row.Flight}_${row.Type}_${row.Segment}`;
      if (!grouped[key]) {
        grouped[key] = { ...row };
      } else {
        Object.keys(row).forEach(col => {
          if (
            !['Flight', 'Date', 'Segment', 'Type'].includes(col) &&
            !isNaN(parseFloat(row[col]))
          ) {
            // grouped[key][col] = (grouped[key][col] || 0) + row[col];
            const prev = !isNaN(parseFloat(grouped[key][col])) ? parseFloat(grouped[key][col]) : 0;
            const curr = !isNaN(parseFloat(row[col])) ? parseFloat(row[col]) : 0;
            grouped[key][col] = prev + curr;
          }
        });
      }
    });

    return Object.values(grouped);
  }

  // Main logic
  billingData.forEach(column => {
    ['inbound', 'outbound'].forEach(type => {
      let flights = column?.[type]?.flights || [];
      if (sheetType === 'Flight Details') {
        const getPlatformGroup = (item) => {
          const p = item.platform;
          if (p === null || p === undefined || p === '') {
            return 3;
          }
          if (p === 'Truck') {
            return 2;
          }
          return 1;
        };
        flights = [...flights].sort((a, b) => {
          const groupA = getPlatformGroup(a);
          const groupB = getPlatformGroup(b);
          if (groupA !== groupB) {
            return groupA - groupB;
          }
          const dateStrA = a.label?.split(' ')?.[0]?.split('/')?.[1];
          const dateStrB = b.label?.split(' ')?.[0]?.split('/')?.[1];
          const dateA = moment(dateStrA, 'DDMMMYY');
          const dateB = moment(dateStrB, 'DDMMMYY');
          return dateA - dateB;
        });
      }

      flights.forEach(flight => {
        let trimlabel = flight.label?.split(' ')?.[0];
        let data = {
          'Flight': trimlabel?.split('/')?.[0],
          'Date': trimlabel?.split('/')?.[1],
          'Segment': `${flight.org} - ${flight.dest}`,
          'Type': type.charAt(0).toUpperCase() + type.slice(1),
          'Platform': flight.platform || '',
        };

        // If noncommercialData is present, sum up the columns
        if (flight.noncommercialData && Array.isArray(flight.noncommercialData) && sheetType) {
          // const nonCommercialCols = getNonCommercialColumns(flight.noncommercialData, sheetType);
          const nonCommercialCols = flight.noncommercialData;
          nonCommercialCols.forEach(nc => {
            // Sum up all contractData rows whose id is in nc.commercial_items
            const sum = sumCommercialItems(flight.contractData || [], nc.commercial_items || [], billingFields);
            data[nc.description] = sum;
          });
        }

        // Always include all contractData items as columns (like get_csv_cont)
        if (flight.contractData && Array.isArray(flight.contractData)) {
          flight.contractData.forEach(row => {
            data[row.item] = getExportQuantity(billingFields, row);
          });
        }

        csv_cont.push(data);
      });
    });
  });

  if (sheetType === 'Flight Summary'){
    if (reportFields.reportType === 'custom' && sheetType === 'Flight Summary'){
      if (
        Array.isArray(flightSumOpts) && flightSumOpts.length > 0
      ) {
        // Get allowed columns from fSumOpts
        const allowedCols = [
          'Flight',
          'Segment',
          'Type',
          ...flightSumOpts.map(opt => opt.title)
        ];

        csv_cont = csv_cont.map(row => {
          let filtered = {};
          allowedCols.forEach(col => {
            if (Object.prototype.hasOwnProperty.call(row, col)) filtered[col] = row[col];
          });
          return filtered;
        });
      }
    }
    csv_cont = groupAndSumRows(csv_cont);
  }

  else if (
    reportFields.reportType === 'custom' && sheetType === 'Flight Details' &&
    Array.isArray(flightDetOpts) && flightDetOpts.length > 0
  ) {
    // Get allowed columns from fDetOpts
    const allowedCols = [
      'Flight',
      'Date',
      'Segment',
      'Type',
      'Platform',
      ...flightDetOpts.map(opt => opt.title)
    ];

    csv_cont = csv_cont.map(row => {
      let filtered = {};
      allowedCols.forEach(col => {
        if (Object.prototype.hasOwnProperty.call(row, col)) filtered[col] = row[col];
      });
      return filtered;
    });
  }
  return csv_cont;
};

const get_tonnage_summary = async (csvContracts = [], contractData = [], reportFields, billingFields, tonSumOpts) => {
  let csv_cont = [];
  let sheetType = [
    'Flight Summary',
    'Flight Details'
  ];

  // 1. For each csvContract, sum up contractData records whose id is in commercial_items
  csvContracts.forEach(contract => {
    if (contract.sheetlist && !sheetType.some(type => contract.sheetlist.includes(type))) return;
    const ids = contract.commercial_items || [];
    // Find all contractData records with id in ids
    const matched = contractData.filter(row => ids.includes(row.row_id));
    // Sum up the fields
    let sum_quantity = 0, sum_dis_quantity = 0;
    let sum_driver = '', sum_source = '';
    matched.forEach(row => {
      sum_quantity += parseFloat(row.quantity) || 0;
      sum_dis_quantity += parseFloat(row.dis_quantity) || 0;
      // Use the first non-empty driver/source for display
      if (!sum_driver && row.applied_on) sum_driver = row.applied_on.split('|')[0]?.trim();
      if (!sum_source && row.applied_on) sum_source = row.applied_on.split('|')[1]?.trim();
    });
    // Only add if there is at least one matched record
    if (matched.length > 0) {
      csv_cont.push({
        'Item': contract.description,
        'Driver': sum_driver,
        'Source': sum_source,
        'Quantity': billingFields.exclude_disc ? sum_quantity : sum_dis_quantity,
      });
    }
  });

  // 2. For contractData records whose id is NOT present in any csvContract's commercial_items, add as-is
  let allCommercialIds = new Set();
  csvContracts.forEach(contract => {
    (contract.commercial_items || []).forEach(id => allCommercialIds.add(id));
  });
  contractData.forEach(row => {
    // if (!allCommercialIds.has(row.row_id)) {
    csv_cont.push({
      'Item': row.label,
      'Driver': row.applied_on ? row.applied_on.split('|')[0]?.trim() : '',
      'Source': row.applied_on ? row.applied_on.split('|')[1]?.trim() : '',
      'Quantity': getExportQuantity(billingFields, row),
    });
    // }
  });

  if (
    reportFields.reportType === 'custom' &&
    Array.isArray(tonSumOpts) &&
    tonSumOpts.length > 0
  ) {
    const allowedItems = tonSumOpts.map(opt => opt.title);
    csv_cont = csv_cont.filter(row => allowedItems.includes(row.Item));
  }
  return csv_cont;
};

const addSummaryRows = (rows) => {
  if (!rows || rows.length === 0) return [];

  // Use the first row's keys as the column order
  const keys = Object.keys(rows[0]);

  function sumRows(type) {
    const filtered = rows.filter(row => row.Type === type);
    const summary = {};
    keys.forEach(key => {
      if (['Flight', 'Date', 'Platform', 'Segment', 'Type'].includes(key)) return;
      summary[key] = filtered.reduce((acc, row) => {
        const val = row[key];
        return acc + (val !== undefined && val !== null && val !== '' && !isNaN(val) ? parseFloat(val) : 0);
      }, 0);
    });
    summary.Flight = type === 'Inbound' ? 'Import' : 'Export';
    summary.Date = '';
    summary.Segment = '';
    summary.Type = type;
    summary.Platform = '';
    // Ensure column order and fill missing columns with 0
    return keys.reduce((acc, key) => {
      acc[key] = summary[key] !== undefined ? summary[key] : 0;
      return acc;
    }, {});
  }

  // Add Total row (sum all rows)
  const totalRow = {};
  keys.forEach(key => {
    if (['Flight', 'Date', 'Segment', 'Type', 'Platform'].includes(key)) return;
    totalRow[key] = rows.reduce((acc, row) => {
      const val = row[key];
      return acc + (val !== undefined && val !== null && val !== '' ? parseFloat(val) || 0 : 0);
    }, 0);
  });
  totalRow.Flight = 'Total';
  totalRow.Date = '';
  totalRow.Platform = '';
  totalRow.Segment = '';
  totalRow.Type = '';
  // Ensure column order
  const totalRowOrdered = keys.reduce((acc, key) => {
    acc[key] = totalRow[key] !== undefined ? totalRow[key] : '';
    return acc;
  }, {});

  // Find first inbound and outbound row indexes
  const firstInboundIdx = rows.findIndex(row => row.Type === 'Inbound');
  const firstOutboundIdx = rows.findIndex(row => row.Type === 'Outbound');

  const result = [...rows];

  if (firstInboundIdx !== -1) {
    result.splice(firstInboundIdx, 0, sumRows('Inbound'));
  }
  if (firstOutboundIdx !== -1) {
    const offset = firstInboundIdx !== -1 && firstOutboundIdx > firstInboundIdx ? 1 : 0;
    result.splice(firstOutboundIdx + offset, 0, sumRows('Outbound'));
  }

  // Insert Total row at the top
  result.unshift(totalRowOrdered);

  return result;
};

const get_service_logs_csv = async (daylogdata = [], monthlogdata = []) => {
  // Only finalized logs
  daylogdata = daylogdata.filter(row => row.status !== 'Not Finalized');
  monthlogdata = monthlogdata.filter(row => row.status !== 'Not Finalized');
  // Helper to flatten contractData for each log
  function flattenContractData(contractData, notes) {
    const result = {};
    contractData.forEach(item => {
      // Use item.label as column prefix
      result[`${item.label.charAt(0).toUpperCase() + item.label.slice(1)} (Quantity)`] = item.quantity;
      // Add more fields if needed
      const filteredNotes = notes.filter(note => note.cont_rowId === item.cont_rowId);
      // set column name as notes and put data comma separated
      result[`${item.label.charAt(0).toUpperCase() + item.label.slice(1)} (Notes)`] = filteredNotes.map(n => n.note).join(', ');
    });
    return result;
  }

  // Build rows for Excel
  let csvRows = [];
  daylogdata.forEach(log => {
    let row = {
      'Label': log.label,
      'Type': log.type,
      ...flattenContractData(log.contractData, log.notes)
    };
    csvRows.push(row);
  });

  monthlogdata.forEach(log => {
    let row = {
      'Label': log.label,
      'Type': log.type,
      ...flattenContractData(log.contractData, log.notes)
    };
    csvRows.push(row);
  });
  return csvRows;
};

const get_csv_stat = async (billingData, billingColumns) => {
  console.log('Statistics Data:!!!!!!!!!!!!!!!!!1,', billingData);
  let csv_stat = [];
  billingData.map((column) => {
    csv_stat = [];
    let data = {
      'Lable': column?.ex_label,
      'Date': '',
      'Segment': '',
      'Sch Arr Date': '',
      'Sch Dept Date': '',
      'Act Arr Date': '',
      'Act Dept Date': '',
      'Flight': column?.flight_count,

    };
    billingColumns.map((c) => {
      let field = c.field;
      // if (this.state.billingFields.exclude_disc) {
      //   field = field.replace('_disc', '');
      // }
      data[c.headerName] = column?.[field];
    });
    csv_stat.push(data);
    data = {};
    data = {
      'Lable': column?.inbound?.ex_label,
      'Date': '',
      'Segment': '',
      'Sch Arr Date': '',
      'Sch Dept Date': '',
      'Act Arr Date': '',
      'Act Dept Date': '',
      'Flight': column?.inbound?.flight_count,
    };
    billingColumns.map((c) => {
      let field = c.field;
      data[c.headerName] = column?.inbound?.[field];
    });
    csv_stat.push(data);
    //inbound flights
    if (column?.inbound?.flights?.length > 0) {
      column?.inbound?.flights.map((flight) => {
        data = {};
        let trimlabel = flight.label?.split(' ')?.[0];
        data = {
          'Lable': trimlabel?.split('/')?.[0],
          'Date': trimlabel?.split('/')?.[1],
          'Segment': `${flight.org} - ${flight.dest}`,
          'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
          'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
          'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
          'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
          'Flight': flight.flight_count,
        };
        billingColumns.map((c) => {
          let field = c.field;
          data[c.headerName] = flight[field];
        });
        csv_stat.push(data);
      });
    }
    data = {};
    data = {
      'Lable': column?.outbound?.ex_label,
      'Date': '',
      'Segment': '',
      'Sch Arr Date': '',
      'Sch Dept Date': '',
      'Act Arr Date': '',
      'Act Dept Date': '',
      'Flight': column?.outbound?.flight_count,
    };
    billingColumns.map((c) => {
      let field = c.field;
      data[c.headerName] = column?.outbound?.[field];
    });
    csv_stat.push(data);
    //outbound flights
    if (column?.outbound?.flights?.length > 0) {
      column?.outbound?.flights.map((flight) => {
        data = {};
        let trimlabel = flight.label?.split(' ')?.[0];
        data = {
          'Lable': trimlabel?.split('/')?.[0],
          'Date': trimlabel?.split('/')?.[1],
          'Segment': `${flight.org} - ${flight.dest}`,
          'Sch Arr Date': flight.schdl_arr ? getStationDate( flight.dest,flight.schdl_arr, 'DDMMMYY') : '',
          'Sch Dept Date': flight.schdl_dept ? getStationDate( flight.org,flight.schdl_dept, 'DDMMMYY') : '',
          'Act Arr Date': flight.act_arr ? getStationDate( flight.dest,flight.act_arr, 'DDMMMYY') : '',
          'Act Dept Date': flight.act_dept ? getStationDate( flight.org,flight.act_dept, 'DDMMMYY') : '',
          'Flight': flight.flight_count,
        };
        billingColumns.map((c) => {
          let field = c.field;
          data[c.headerName] = flight[field];
        });
        csv_stat.push(data);
      });
    }
  });
  return csv_stat;
};

export const handleExport = async (contractData, billingFields, billingData, flightList, csvContracts, reportFields, flightSumOpts, flightDetOpts,
  tonSumOpts, daylogdata, monthlogdata, billingColumns, searchFields,
  fetchInvoiceData, fetchProducts, fetchDiscrepancies ) => {
  // const state = { ...this.state };
  let csv_discdetails = [{}];
  let csv_contract = [{}];
  let csv_stat = [{}];
  let csv_disc = [{}];
  let csv_invoice = [{}];
  let csv_flightsummary =  [{}];
  let csv_flightdetails =  [{}];
  let tonngage_summary = [{}];
  let csv_servicelogs = [{}];
  await fetchInvoiceData(false, 'excel', async (status, contractData, csvContracts, daylogdata, monthlogdata, billingData) => {
    if (status) {
      if (contractData && contractData.length > 0) {
        csv_contract = contractData
          .filter((item) => item.is_nonbillable !== true)
          .map((row) => {
            return {
              Item: row.item,
              Driver: row.driver,
              Source: row.source,
              Quantity: getExportQuantity(billingFields, row),
            };
          });
        csv_invoice = (await get_csv_cont(billingData, billingFields)) || [{}];
        csv_flightsummary = (await get_csvpage_cont( 'Flight Summary', billingFields, billingData, reportFields, flightSumOpts, flightDetOpts)) || [{}];
        csv_flightdetails = (await get_csvpage_cont( 'Flight Details', billingFields, billingData, reportFields, flightSumOpts, flightDetOpts)) || [{}];
        tonngage_summary = (await get_tonnage_summary(csvContracts, contractData, reportFields, billingFields, tonSumOpts)) || [{}];
        csv_servicelogs = (await get_service_logs_csv(daylogdata, monthlogdata)) || [{}];

        //add missing labels from rows in csv_flightsummary and csv_flightdetails
        // Get all unique keys from all rows
        const allKeys1 = Array.from(
          new Set(csv_flightsummary.flatMap((row) => Object.keys(row)))
        );
        // Normalize each row to have all keys, filling missing values with 0
        csv_flightsummary = csv_flightsummary.map((row) => {
          const normalized = {};
          allKeys1.forEach((key) => {
            // Keep original value if present, else set to 0 (except for Flight, Date, Segment, Type)
            if (['Flight', 'Segment', 'Type'].includes(key)) {
              normalized[key] = row[key] !== undefined ? row[key] : '';
            } else {
              normalized[key] = row[key] !== undefined ? row[key] : 0;
            }
          });
          return normalized;
        });
        const allKeys2 = Array.from(
          new Set(csv_flightdetails.flatMap((row) => Object.keys(row)))
        );
        // Normalize each row to have all keys, filling missing values with 0
        csv_flightdetails = csv_flightdetails.map((row) => {
          const normalized = {};
          allKeys2.forEach((key) => {
            // Keep original value if present, else set to 0 (except for Flight, Date, Segment, Type, Platform)
            if (['Flight', 'Date', 'Segment', 'Type', 'Platform'].includes(key)) {
              normalized[key] = row[key] !== undefined ? row[key] : '';
            } else {
              normalized[key] = row[key] !== undefined ? row[key] : 0;
            }
          });
          return normalized;
        });

        // Usage before filtering with fs_labels:
        csv_flightsummary = await addSummaryRows(csv_flightsummary); 
        csv_flightsummary = csv_flightsummary.map((row) => {
          const { Date: _Date, ...rest } = row;
          return rest;
        });
        csv_flightdetails = await addSummaryRows(csv_flightdetails);
      }
    }
    // this.setState({
    //   flightList: [],
    //   billingData: [],
    //   filteredData: [],
    //   contractData: [],
    //   accord_id: null,
    //   accord_type: null,
    // });
    fetchProducts('excel', async (status, billingData, billingColumns) => {
      console.log('fetchProducts billingColumns++++++++++++++++++++++++++++++++++', billingData);
      if (status) {
        csv_stat = (await get_csv_stat(billingData, billingColumns)) || [{}]; 
      }
      // this.setState({
      //   flightList: [],
      //   billingData: [],
      //   filteredData: [],
      //   contractData: [],
      //   accord_id: null,
      //   accord_type: null,
      // });
      fetchDiscrepancies(null, 'excel', async (status, flightList) => {
        console.log('fetchDiscrepancies status', status);
        if (status) {
          if (billingData.length > 0) {
            csv_disc = [];
            discrepancyType.map((type) => {
              csv_disc.push({
                Type: type,
                Total: billingData[0][type],
                Inbound: billingData[0]?.inbound[type],
                Outbound: billingData[0]?.outbound[type],
              });
            });
          }
          console.log('flightList______________________', flightList.length);
          if (flightList.length > 0) {
            let inbound_data = flightList[0].inbound || [];
            let outbound_data = flightList[0].outbound || [];
            await Promise.all(
              inbound_data.map(async (flight) => {
                console.log('flight?.flight_discrepancies______________________', flight?.flight_discrepancies.length);
                if (
                  flight?.flight_discrepancies &&
                  flight.flight_discrepancies.length > 0
                ) {
                  flight.flight_discrepancies.map((disc) => {
                    csv_discdetails.push({
                      Flight:
                        '' + flightList[0].code + flight.flight_no,
                      Date: flight?.flight_date,
                      Type: 'Inbound',
                      'Discrepancy Type': disc.type,
                      'ULD Number': disc.uld_no,
                      'Handled As': disc.handled_as,
                      Segment: disc.segment === 'null' ? '' : disc.segment,
                      'ULD Type':
                        disc.uld_type === 'null' ? '' : disc.uld_type,
                      'AWB Number': disc.awb_no,
                      Org: disc.org,
                      Dest: disc.dest,
                      'Total Pcs': disc.t_pcs,
                      'Total Wgt': disc.t_wgt,
                      'Dscpy Pcs': disc.d_pcs,
                      'Dscpy Wgt': disc.d_wgt,
                      Remarks: disc.description,
                    });
                  });
                }
              })
            );
            await Promise.all(
              outbound_data.map(async (flight) => {
                console.log('flight?.flight_discrepancies______________________', flight?.flight_discrepancies.length);
                if (
                  flight?.flight_discrepancies &&
                  flight.flight_discrepancies.length > 0
                ) {
                  flight.flight_discrepancies.map((disc) => {
                    csv_discdetails.push({
                      Flight:
                        '' + flightList[0].code + flight.flight_no,
                      Date: flight?.flight_date,
                      Type: 'Outbound',
                      'Discrepancy Type': disc.type,
                      'ULD Number': disc.uld_no,
                      'Handled As': disc.handled_as,
                      Segment: disc.segment === 'null' ? '' : disc.segment,
                      'ULD Type':
                        disc.uld_type === 'null' ? '' : disc.uld_type,
                      'AWB Number': disc.awb_no,
                      Org: disc.org,
                      Dest: disc.dest,
                      'Total Pcs': disc.t_pcs,
                      'Total Wgt': disc.t_wgt,
                      'Dscpy Pcs': disc.d_pcs,
                      'Dscpy Wgt': disc.d_wgt,
                      Remarks: disc.description,
                    });
                  });
                }
              })
            );
          }
        }

        const allKeys1 = Array.from(
          new Set(tonngage_summary.flatMap((row) => Object.keys(row)))
        );

        const allKeys2 = Array.from(
          new Set(csv_flightsummary.flatMap((row) => Object.keys(row)))
        );
        const allKeys3 = Array.from(
          new Set(csv_flightdetails.flatMap((row) => Object.keys(row)))
        );
        const allKeys8 = Array.from(
          new Set(csv_discdetails.flatMap((row) => Object.keys(row)))
        );
        const allKeys4 = Array.from(
          new Set(csv_contract.flatMap((row) => Object.keys(row)))
        );
        console.log('csv_stat', csv_stat);
        const allKeys5 = Array.from(
          new Set(csv_stat.flatMap((row) => Object.keys(row)))
        );
        const allKeys6 = Array.from(
          new Set(csv_disc.flatMap((row) => Object.keys(row)))
        );
        const allKeys7 = Array.from(
          new Set(csv_invoice.flatMap((row) => Object.keys(row)))
        );
        const allKeys9 = Array.from(
          new Set(csv_servicelogs.flatMap((row) => Object.keys(row)))
        );

        // const worksheet1 = XLSX.utils.json_to_sheet(csv_contract, { header: Object.keys(csv_contract?.[0]) });
        // const worksheet2 = XLSX.utils.json_to_sheet(csv_stat, { header: Object.keys(csv_stat[0]) });
        // const worksheet3 = XLSX.utils.json_to_sheet(csv_disc, { header: Object.keys(csv_disc[0]) });
        // const worksheet4 = XLSX.utils.json_to_sheet(csv_invoice, { header: Object.keys(csv_invoice[0]) });
        // const worksheet5 = XLSX.utils.json_to_sheet(csv_flightsummary, { header: Object.keys(csv_flightsummary[0]) });
        // const worksheet6 = XLSX.utils.json_to_sheet(csv_flightdetails, { header: Object.keys(csv_flightdetails[0]) });
        const worksheet1 = XLSX.utils.json_to_sheet(tonngage_summary, { header: allKeys1, });
        const worksheet2 = XLSX.utils.json_to_sheet(csv_flightsummary, { header: allKeys2, });
        const worksheet3 = XLSX.utils.json_to_sheet(csv_flightdetails, { header: allKeys3, });
        const worksheet8 = XLSX.utils.json_to_sheet(csv_discdetails, { header: allKeys8, });
        const worksheet4 = XLSX.utils.json_to_sheet(csv_contract, { header: allKeys4, });
        const worksheet5 = XLSX.utils.json_to_sheet(csv_stat, { header: allKeys5, });
        const worksheet6 = XLSX.utils.json_to_sheet(csv_disc, { header: allKeys6, });
        const worksheet7 = XLSX.utils.json_to_sheet(csv_invoice, { header: allKeys7, });
        const worksheet9 = XLSX.utils.json_to_sheet(csv_servicelogs, { header: allKeys9, });

        worksheet1['!cols'] = allKeys1.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...tonngage_summary.map((row) =>
              row[key] ? String(row[key]).length : 0
            )
          );
          return { wch: maxLen + 2 };
        });

        // Set column widths for worksheet2
        worksheet2['!cols'] = allKeys2.length > 0
          ? [
            { wch: Math.round(7.45 * 3.78) },
            ...Array(Math.max(0, allKeys2.length - 1)).fill({ wch: Math.round(2.62 * 3.78) }),
          ]
          : [];
        // Set wrap text for all cells in Row 1 (header) of worksheet2
        const range2 = XLSX.utils.decode_range(worksheet2['!ref']);
        for (let C = range2.s.c; C <= range2.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({
            r: 0,
            c: C,
          });
          if (worksheet2[cellAddress]) {
            worksheet2[cellAddress].s = worksheet2[cellAddress].s || {};
            worksheet2[cellAddress].s.alignment =
              worksheet2[cellAddress].s.alignment || {};
            worksheet2[cellAddress].s.alignment.wrapText = true;
          }
        }
        // Set background color for 'Total', 'Import', 'Export' rows in worksheet2
        for (let R = range2.s.r; R <= range2.e.r; ++R) {
          const cellA = XLSX.utils.encode_cell({
            r: R,
            c: 0,
          }); // Column A
          const valueA = worksheet2[cellA]?.v;
          let fillColor = null;
          if (valueA === 'Total') fillColor = 'FFC000';
          if (valueA === 'Import' || valueA === 'Export')
            fillColor = 'FFFF00';

          if (fillColor) {
            for (let C = 0; C < allKeys2.length; ++C) {
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C,
              });
              if (!worksheet2[cellAddress]) {
                worksheet2[cellAddress] = {
                  t: 's',
                  v: '',
                };
              }
              worksheet2[cellAddress].s = worksheet2[cellAddress].s || {};
              worksheet2[cellAddress].s.fill = {
                patternType: 'solid',
                fgColor: { rgb: fillColor },
              };
            }
          }
        }
        // Set Row 1 height for worksheet2
        worksheet2['!rows'] = worksheet2['!rows'] || [];
        worksheet2['!rows'][0] = { hpt: 1.69 * 28.35 };

        // Set column widths for worksheet3
        worksheet3['!cols'] = allKeys3.length > 0
          ? [
            { wch: Math.round(7.45 * 3.78) },
            ...Array(Math.max(0, allKeys3.length - 1)).fill({ wch: Math.round(2.62 * 3.78) }),
          ]
          : [];
        // Set wrap text for all cells in Row 1 (header) of worksheet3
        const range = XLSX.utils.decode_range(worksheet3['!ref']);
        // Set wrap text for all cells in Column A
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({
            r: 0,
            c: C,
          }); // Row 1 = r:0
          if (worksheet3[cellAddress]) {
            worksheet3[cellAddress].s = worksheet3[cellAddress].s || {};
            worksheet3[cellAddress].s.alignment =
              worksheet3[cellAddress].s.alignment || {};
            worksheet3[cellAddress].s.alignment.wrapText = true;
          }
        }
        for (let R = range.s.r; R <= range.e.r; ++R) {
          const cellA = XLSX.utils.encode_cell({
            r: R,
            c: 0,
          }); // Column A
          const valueA = worksheet3[cellA]?.v;
          let fillColor = null;
          if (valueA === 'Total') fillColor = 'FFC000';
          if (valueA === 'Import' || valueA === 'Export')
            fillColor = 'FFFF00';

          if (fillColor) {
            for (let C = 0; C < allKeys3.length; ++C) {
              // Use allKeys3.length for full column coverage
              const cellAddress = XLSX.utils.encode_cell({
                r: R,
                c: C,
              });
              // Create cell if missing, so color is applied even to empty cells
              if (!worksheet3[cellAddress]) {
                worksheet3[cellAddress] = {
                  t: 's',
                  v: '',
                };
              }
              worksheet3[cellAddress].s = worksheet3[cellAddress].s || {};
              worksheet3[cellAddress].s.fill = {
                patternType: 'solid',
                fgColor: { rgb: fillColor },
              };
            }
          }
        }
        // Set Row 1 height (cm to Excel's 'hpt' units: 1 cm ≈ 28.35 hpt)
        worksheet3['!rows'] = worksheet3['!rows'] || [];
        worksheet3['!rows'][0] = { hpt: 1.69 * 28.35 };

        worksheet8['!cols'] = allKeys8.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...csv_discdetails.map((row) =>
              row[key] ? String(row[key]).length : 0
            )
          );
          return { wch: maxLen + 2 };
        });

        worksheet4['!cols'] = allKeys4.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...csv_contract.map((row) =>
              row[key] ? String(row[key]).length : 0
            )
          );
          return { wch: maxLen + 2 };
        });
        worksheet5['!cols'] = allKeys5.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...csv_stat.map((row) => (row[key] ? String(row[key]).length : 0))
          );
          return { wch: maxLen + 2 };
        });
        worksheet6['!cols'] = allKeys6.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...csv_disc.map((row) => (row[key] ? String(row[key]).length : 0))
          );
          return { wch: maxLen + 2 };
        });
        worksheet7['!cols'] = allKeys7.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...csv_invoice.map((row) =>
              row[key] ? String(row[key]).length : 0
            )
          );
          return { wch: maxLen + 2 };
        });

        worksheet9['!cols'] = allKeys9.map((key) => {
          const maxLen = Math.max(
            key.length,
            ...csv_servicelogs.map((row) =>
              row[key] ? String(row[key]).length : 0
            )
          );
          return { wch: maxLen + 2 };
        });

        // // header bold
        // worksheet1['!rows'] = [{ bold: true }];

        // worksheet1['!cols'] = [
        //   { wch: 50 },
        //   { wch: 20 },
        //   { wch: 20 },
        // ];
        // worksheet2['!cols'] = [
        //   { wch: 30 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        // ];

        // worksheet3['!cols'] = [
        //   { wch: 30 },
        //   { wch: 10 },
        //   { wch: 10 },
        //   { wch: 10 },
        // ];

        // worksheet4['!cols'] = [
        //   { wch: 10 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        //   { wch: 20 },
        // ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet1, 'Tonnage Summary');
        XLSX.utils.book_append_sheet(workbook, worksheet2, 'Flight Summary');
        XLSX.utils.book_append_sheet(workbook, worksheet3, 'Flight Details');
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet8,
          'Discrepancy Details'
        );
        // XLSX.utils.book_append_sheet(workbook, worksheet4, 'Contract Data');
        XLSX.utils.book_append_sheet(workbook, worksheet5, 'Statistics');
        // XLSX.utils.book_append_sheet(workbook, worksheet6, 'Discrepancy');
        // XLSX.utils.book_append_sheet(workbook, worksheet7, 'Invoice');
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet9,
          'Service Logs Details'
        );

        // Generate XLSX file and trigger download
        const excelBuffer = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array',
          cellStyles: true,
        });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream', });
        let filename = 'Flight Load Info';

        // Build filename parts from billingFields
        const parts = [];
        console.log('searchFields++++++++++++++++++++++', searchFields);
        parts.push(searchFields.month);
        if (!billingFields?.exclude_disc) parts.push('dis'); 
        if (billingFields?.transit && billingFields.transit !== 'none') parts.push(billingFields.transit);
        if (billingFields?.priority && (billingFields.transit === 'flight' || billingFields.transit === 'truck') ) parts.push(billingFields.priority);

        if (parts.length > 0) {
          filename += ' - ' + parts.join('_');
        }

        filename += '.xlsx';

        saveAs(blob, filename);
        // this.setState({ ...state });
      });
    });
  });
    
};
